<template>
  <div class="staff_item">
    <div class="img">
      <slot name="img"></slot>
    </div>
    <div class="text">
      <slot name="text"></slot>
    </div>
    <div class="desc">
      <slot name="desc"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<style lang="less" scoped>
.staff_item {
  height: 2.2rem;
  width: 2.8rem;
  background-color: #fff;
  border-radius: 5%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  .img {
    text-align: center;
    padding: 0.25rem 0;
    margin-top: 0.1rem;
    width: 0.64rem;
    height: 0.64rem;
    margin: 0 auto 0.4rem auto;
    img {
      width: 100%;
    }
  }
  .text {
    text-align: center;
    font-size: 0.18rem;
    margin-bottom: 0.3rem;
    p {
      font-size: 0.18rem;
    }
  }
  .desc {
    padding: 0 0.26rem;
    font-size: 0.12rem;
    line-height: 0.2rem;
    font-weight: 400;
    p {
      line-height: 0.32rem;
    }
  }
}
.staff_item:hover {
  background-color: #d0e7f9;
  box-shadow: -2px 8px 10px 0px #b5b2b2;
  cursor: pointer;
}
</style>
